export default __webpack_public_path__ + "static/media/screenshot.20f28eff.svg";